<template>
  <div class="order-details">
    <div v-if="!editEnabled && isPickupTimeEnabled" class="estimated-time">
      <p class="estimated-time-title">Estimated Time:</p>
      <p class="estimated-time-detail">
        <b>{{ `Today at ${getFormattedPickupTime()}` }}</b>
      </p>
    </div>
    <h2 class="order-detail-title">Order Details</h2>
    <ul class="order-detail-items">
      <li>
        <span><b>From:</b> {{ activeVendor.name }}</span>
      </li>
      <li v-if="editEnabled && isPickupTimeEnabled">
        <span><b>Ready at:</b> {{ getFormattedPickupTime() }}</span>
        <span><app-link class="pickuptime__link" :route-to="{}" @click="showPickupTimeSelection">Edit</app-link></span>
      </li>
      <li v-if="seatRequired">
        <span class="seat-selection">
          <b>Seat:</b>
          <ul class="seat-selection-details">
            <li>{{ layout.levelLabel }}: {{ selectedLevel?.name }}</li>
            <li>{{ layout.sectionLabel }}: {{ selectedSection?.name }}</li>
            <li>{{ layout.rowLabel }}: {{ selectedRow?.name }}</li>
            <li>{{ layout.seatLabel }}: {{ selectedSeat?.name }}</li>
          </ul>
        </span>
        <span v-if="editEnabled">
          <app-link class="seatSelector__link" :route-to="{}" @click="showSeatSelector">Edit</app-link>
        </span>
      </li>
    </ul>
    <div v-if="subVendorLocations">
      <location-list-item v-for="(location, index) in getSubvendorLocations" :key="index" :location="location" />
    </div>
  </div>
</template>

<!-- prettier-ignore -->
<script>

/* eslint-disable no-undef */
import { mapActions, mapGetters } from "vuex";
import AppLink from "@/components/base/app-link/AppLink";
import pickupTimeMixin from "@/mixins/pickup-time.mixin";
import vendorDialogMixin from "@/mixins/vendor-dialog.mixin";
import LocationListItem from "./LocationListItem";
import { sortByObjectProp, ROUTE_NAMES, OAPI_API_TYPE } from "@/utils";
import { useOrderAheadMapper } from "@/store/modules/orderAhead/mapper";

const { mapToEndTime } = useOrderAheadMapper();

export default {
  name: "OrderDetails",
  components: {
    AppLink,
    LocationListItem
  },
  mixins: [pickupTimeMixin, vendorDialogMixin],
  props: {
    editEnabled: Boolean
  },
  computed: {
    ...mapGetters({
      // venue
      venueInfo: "venue/getVenueInfo",
      activeVendor: "vendor/getActiveVendor",

      selectedPickup: "orderAhead/selectedPickup",
      subVendorLocations: "cart/getCartItemsSubvendorLocations",
      //seat selection
      seatRequired: "venueSettings/seatRequired",
      selectedLevel: "delivery/getSelectedLevel",
      selectedSection: "delivery/getSelectedSection",
      selectedRow: "delivery/getSelectedRow",
      selectedSeat: "delivery/getSelectedSeat",
      layout: "venueSettings/getLayout",
      APIType: "venueSettings/APIType",
    }),
    isPickupTimeEnabled() {
        return this.APIType === OAPI_API_TYPE && this.activeVendor?.pickupTimeSelectionEnabled
    },
    getSubvendorLocations() {      
      if (!this.subVendorLocations || !Object.keys(this.subVendorLocations).length) return [];
      return sortByObjectProp(Object.values(this.subVendorLocations), "location");
    }
  },

  methods: {
    ...mapActions("vendor", ["detectClosedVendors"]),
    async showPickupTimeSelection() {
      await this.detectClosedVendors([this.activeVendor]);
      const isOpen = await this.checkVendorIsOpen();
      if (!isOpen) return;

      this.showPickupTimeOptions(this.activeVendor.id);
    },
    getFormattedPickupTime() {
      return mapToEndTime(this.selectedPickup, this.venueInfo.timezone).toFormat("hh:mm a")
    },
    showSeatSelector() {
      this.$router.push({
        name: ROUTE_NAMES.VENUE_CONTAINER,
        params: {
          returnTo: ROUTE_NAMES.CHECKOUT
        }
      });
    }
  }
};
</script>

<style scoped lang="scss">
.order-detail-items {
  font-size: 14px;
  padding: 0;
  margin: 5px 0 0 0;

  li {
    flex-grow: 1;
    padding: 0px 0px 5px 0px;
    display: flex;
    justify-content: space-between;
    margin: 0 0 0 5px;
  }
}
h2.order-detail-title {
  color: #000;
  font-size: 16px;
  padding-top: 10px;
}
.seat-selection {
  display: flex;
}
.seat-selection-details {
  font-size: 14px;
  padding: 0;
  display: flex;
  margin-top: -5px;

  li {
    flex-grow: 1;
    padding: 5px 0px 5px 0px;
    display: flex;
    justify-content: space-between;
    margin: 0 0 0 5px;
  }
}

.estimated-time {
  border-bottom: 1px solid $border-color;
}

.estimated-time-detail {
  font-size: 20px;
  margin-top: 5px;
}

.estimated-time-title {
  font-size: 14px;
  margin-bottom: 0;
}
</style>
